import { createAction, props } from '@ngrx/store';
import { PersonAddress } from '../_models';

// Load Actions
export const loadPersonAddresses = createAction('[PersonAddress] Load PersonAddresses');
export const loadPersonAddressesSuccess = createAction(
  '[PersonAddress] Load PersonAddresses Success',
  props<{ personAddresses: PersonAddress[] }>()
);
export const loadPersonAddressesFailure = createAction(
  '[PersonAddress] Load PersonAddresses Failure',
  props<{ error: any }>()
);

// Add Actions
export const addPersonAddress = createAction(
  '[PersonAddress] Add PersonAddress',
  props<{ personAddress: PersonAddress }>()
);
export const addPersonAddressSuccess = createAction(
  '[PersonAddress] Add PersonAddress Success',
  props<{ personAddress: PersonAddress }>()
);
export const addPersonAddressFailure = createAction(
  '[PersonAddress] Add PersonAddress Failure',
  props<{ error: any }>()
);

// Update Actions
export const updatePersonAddress = createAction(
  '[PersonAddress] Update PersonAddress',
  props<{ personAddress: PersonAddress }>()
);
export const updatePersonAddressSuccess = createAction(
  '[PersonAddress] Update PersonAddress Success',
  props<{ personAddress: PersonAddress }>()
);
export const updatePersonAddressFailure = createAction(
  '[PersonAddress] Update PersonAddress Failure',
  props<{ error: any }>()
);

// Delete Actions
export const deletePersonAddress = createAction(
  '[PersonAddress] Delete PersonAddress',
  props<{ id: number }>()
);
export const deletePersonAddressSuccess = createAction(
  '[PersonAddress] Delete PersonAddress Success',
  props<{ id: number }>()
);
export const deletePersonAddressFailure = createAction(
  '[PersonAddress] Delete PersonAddress Failure',
  props<{ error: any }>()
);
